import { http } from '../../http';

export default {
    state: {
        settings: {},
        loaded: false,
        loading: false
    },

    mutations: {
        setSettings(state, settings) {
            state.settings = settings;
        },
    },

    getters: {
        getSettings(state, getters) {
            return state.settings;
        },

        isLoaded(state, getters) {
            return state.loaded;
        }
    },

    actions: {
        loadSettings ({ state, dispatch }) {
            if (state.loaded || state.loading) {
                return;
            }

            dispatch('forceLoadSettings');
        },

        forceLoadSettings ({ state, commit }) {
            state.loading = true;

            http.get('/app/user/settings/practitioners')
                .then(({ data }) => {
                    state.loading = false;
                    commit('setSettings', data);
                    state.loaded = true;
                })
                .catch(() => {
                    state.loading = false;
                });
        }

    }
};
